import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "../../css/Contact.css";
import { FaPhoneAlt } from "react-icons/fa";
import { FaUserEdit, FaRegBuilding } from "react-icons/fa";
import { MdMailOutline } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { TfiWorld } from "react-icons/tfi";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-phone-number-input/style.css";
import { Helmet } from "react-helmet-async";

import toast, { Toaster } from "react-hot-toast";

import axios from "axios";

/* IMAGES */
import contactImg from "../../../assets/contact.png";

/* CAPTCHA */
import Captcha from "./Captcha";
import countryOptions from "./CountryOptions";

function ContactUS() {
  const captchaRef = useRef(null);
  const location = useLocation();
  const title = "Best Test Management Tools for Businesses Now";
  const description =
    "Maximize QA efficiency and software quality with the best test management tools for businesses, ensuring reliable, smooth, and effective testing workflows.";

  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    designation: "",
    message: "",
  });

  /* ================= HANDLE CHANGE ================= */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isCaptchaValid) {
      toast.error("Please complete captcha");
      return;
    }

    const payload = {
      company: formData.company,
      last_name: formData.name,
      email: formData.email,
      phone: formData.phone,
      designation: formData.designation,
      message: formData.message,
    };

    try {
      const response = await axios.post(
       "https://frothtestops.com/api/create_lead",
        payload,
      );

      if (response?.data?.status === "success") {
        toast.success("Thank you for contacting us.");

        setFormData({
          name: "",
          phone: "",
          email: "",
          company: "",
          designation: "",
          message: "",
        });

        setIsCaptchaValid(false);

        captchaRef.current?.resetCaptcha();
      } else {
        toast.error("Something went wrong.");
      }
    } catch (error) {
  console.error(error);

  if (error?.response?.data?.detail?.length > 0) {
    error.response.data.detail.forEach((err) => {
      const cleanMessage = err.message.replace("Value error, ", "");

      toast.error(cleanMessage);
    });
  } else {
    toast.error("Submission failed.");
  }
}
  };

  return (
    <>
      <Helmet>
        <title>Best Test Management Tools for Businesses Now</title>

        <meta
          name="description"
          content="Maximize QA efficiency and software quality with the best test management tools for businesses, ensuring reliable, smooth, and effective testing workflows."
        />

        <meta
          name="keywords"
          content="best test management tools for businesses"
        />

        <link rel="canonical" href="https://frothtestops.com/contact" />

        {/* Open Graph Tags */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/images/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://frothtestops.com${location.pathname}`}
        />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="/images/og-image.jpg" />
      </Helmet>
      <Toaster position="top-right" />

      <section className="contact-section">
        <div className="contact-wrapper">
          {/* LEFT SIDE */}
          <div className="contact-left">
            <h2>Get in Touch</h2>

            <h3>Let's build something unique!</h3>

            <img src={contactImg} alt="contact" />
          </div>

          {/* RIGHT SIDE */}
          <div className="contact-right">
            <form onSubmit={handleSubmit}>
              <div className="contact-grid">
                {/* NAME */}
                <div className="contact-field">
                  <label>Name*</label>

                  <div className="input-wrapper">
                    <FaUserEdit className="input-icon" />

                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                      maxLength={150}
                    />
                  </div>
                </div>

                {/* PHONE */}
                <div className="contact-field">
                  <label>Mobile Number*</label>

                  <PhoneInput
                    country={"in"}
                    value={formData.phone}
                    onChange={(phone) =>
                      setFormData((prev) => ({
                        ...prev,
                        phone,
                      }))
                    }
                    inputProps={{
                      required: true,
                      autoComplete: "off",
                    }}
                    className="phone-flex"
                    containerClass="phone-container"
                    inputClass="phone-input-custom"
                    buttonClass="phone-dropdown"
                    dropdownClass="phone-dropdown-list"
                    placeholder="Mobile Number"
                  />
                </div>

                {/* EMAIL */}
                <div className="contact-field">
                  <label>Email*</label>

                  <div className="input-wrapper">
                    <MdMailOutline className="input-icon" />

                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                    />
                  </div>
                </div>

                {/* COMPANY */}
                <div className="contact-field">
                  <label>Company*</label>

                  <div className="input-wrapper">
                    <FaRegBuilding className="input-icon" />

                    <input
                      type="text"
                      name="company"
                      placeholder="Company"
                      value={formData.company}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                    />
                  </div>
                </div>

                {/* DESIGNATION */}
                <div className="contact-field">
                  <label>Designation*</label>

                  <div className="input-wrapper">
                    <IoSettingsOutline className="input-icon" />

                    <input
                      type="text"
                      name="designation"
                      placeholder="Designation"
                      value={formData.designation}
                      onChange={handleChange}
                      required
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>

              {/* MESSAGE */}
              <div className="message-wrapper">
                <label>Message*</label>

                <textarea
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  required
                  autoComplete="off"
                />
              </div>

              {/* CAPTCHA */}
              <div className="captcha-wrapper">
                <Captcha ref={captchaRef} onSolvedChange={setIsCaptchaValid} />
              </div>

              {/* BUTTON */}
              <div className="submit-wrapper">
                <button type="submit" disabled={!isCaptchaValid}>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactUS;
